import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';

import App  from './components/App';
import * as serviceWorker from './serviceWorker';
// import "react-table/react-table.css";
// import setDefaultStartUrl from './setDefaultStartUrl';

// import 'antd/dist/antd.less';
// import 'antd/es/breadcrumb/style/index.less';
// import 'antd/es/button/style/index.less';
import './styles/index.scss';
// import { cryptifyData } from 'Tests';
import { SetupApp } from 'Setup';

// cryptifyData();

SetupApp(onSetupComplete);

console.log('navigator language', navigator.language);

function onSetupComplete()
{
	// setDefaultStartUrl();
	ReactDOM.render(<App />, document.getElementById('root'));

	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: https://bit.ly/CRA-PWA
	serviceWorker.unregister();
}